import React from 'react';

export default (
  <svg width="19px" height="12px" viewBox="0 0 19 12">
    <g
      id="Policy-Management"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Payments---Poor-Standing---Add-New-Method---Card2"
        transform="translate(-363.000000, -242.000000)"
      >
        <g id="mc_symbol" transform="translate(362.000000, 241.000000)">
          <g id="Group" opacity="0" fill="#FFFFFF">
            <rect
              id="Rectangle"
              x="0"
              y="0"
              width="20.5108356"
              height="13.5496252"
            ></rect>
          </g>
          <rect
            id="Rectangle"
            fill="#FF5F00"
            x="7.55087236"
            y="2.36065967"
            width="5.41065197"
            height="8.82674663"
          ></rect>
          <path
            d="M8.10817264,6.77481259 C8.10681409,5.0526539 8.89832276,3.42551032 10.2546373,2.36221889 C7.95047232,0.553531312 4.64159903,0.816982299 2.65340463,2.96742558 C0.66521023,5.11786886 0.66521023,8.43331555 2.65340463,10.5837588 C4.64159903,12.7342021 7.95047232,12.9976531 10.2546373,11.1889655 C8.89789114,10.1253364 8.10633411,8.49751845 8.10817264,6.77481259 Z"
            id="Path"
            fill="#EB001B"
          ></path>
          <path
            d="M18.9331221,10.8836273 L18.9331221,10.180597 L19.0997888,10.180597 L19.0997888,10.0351424 L18.7031221,10.0351424 L18.7031221,10.180597 L18.8597888,10.180597 L18.8597888,10.8836273 L18.9331221,10.8836273 Z M19.7031221,10.8836273 L19.7031221,10.0351424 L19.5831221,10.0351424 L19.4431221,10.641203 L19.3031221,10.0351424 L19.1831221,10.0351424 L19.1831221,10.8836273 L19.2697888,10.8836273 L19.2697888,10.241203 L19.3997888,10.7927182 L19.4897888,10.7927182 L19.6197888,10.241203 L19.6197888,10.8836273 L19.7031221,10.8836273 Z"
            id="Shape"
            fill="#F79E1B"
            fillRule="nonzero"
          ></path>
          <path
            d="M19.3478421,6.77481259 C19.3478421,8.92394537 18.1191933,10.8843953 16.1838369,11.8235517 C14.2484805,12.7627081 11.9461435,12.5156897 10.2546373,11.1874063 C11.61036,10.1232122 12.4019283,8.49628491 12.4019283,6.77403298 C12.4019283,5.05178105 11.61036,3.42485381 10.2546373,2.36065967 C11.9461435,1.03237622 14.2484805,0.785357883 16.1838369,1.7245143 C18.1191933,2.66367071 19.3478421,4.6241206 19.3478421,6.77325337 L19.3478421,6.77481259 Z"
            id="Path"
            fill="#F79E1B"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);
